/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { optimizeFieldSchemeEntryPoint } from '@jira/site-optimizer__optimize-field-scheme/src/optimizeFieldSchemeEntryPoint.entrypoint.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsOptimizeFieldSchemeRoute } from '@jira/router-routes__admin-pages-field-schemes-routes/src/globalSettingsOptimizeFieldSchemeRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const optimizeFieldSchemePageEntrypoint = createPageEntryPoint({
	main: optimizeFieldSchemeEntryPoint,
});

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

export const globalSettingsOptimizeFieldSchemeRouteEntry: Route = createEntry(
	globalSettingsOptimizeFieldSchemeRoute,
	() => ({
		group: 'global-settings',

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		canTransitionIn: () => fg('slt1-1200-content-changes-for-nfa'),

		entryPoint: () => {
			if (!fg('slt1-1200-content-changes-for-nfa')) {
				return notFoundPageEntrypoint;
			}
			return optimizeFieldSchemePageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
			enabled: true,
		},
	}),
);
